import http from './http';
import axios from 'axios';

//获取登录验证码
const _getLoginCode = () => {
  return axios.post(`/api/captcha`).then(res => res.data)
};
//确认登录
const _confirmLogin = (data) => {
  return http.post(`/api/admin/login`, data).then(res => res.data)
};
//获取短信验证码
const _getCaptcha = (data) => {
  return http.post(`/api/passports`, data).then(res => res.data)
};
//获取学校列表
const _getSchoolsList = (data) => {
  return http.get(`/api/waiter/schools`, data).then(res => res.data)
};
// 获取学生列表
const _getStudentList = (data) => {
  return http.get(`/api/waiter/students`, data).then(res => res.data)
};
//查询学校详情
const _getStudentDetail = (id) => {
  return http.get(`/api/waiter/students/${id}`).then(res => res.data)
};
//查询班级列表
const _getClassesList = (data) => {
  return http.get(`/api/waiter/classes`, data).then(res => res.data)
};
//查询班级详情
const _getClassDetail = (id) => {
  return http.get(`/api/waiter/classes/${id}`).then(res => res.data)
};
//查询用户列表
const _getUserList = (data) => {
  return http.get(`/api/waiter/users`, data).then(res => res.data)
};
//查询用户详情
const _getUserDetail = (id) => {
  return http.get(`/api/waiter/users/${id}`).then(res => res.data)
};
//获取班级邀请码
const _getWxCode = (id) => {
  return http.get(`/api/wx/gzh/qr-codes/${id}`).then(res => res.data)
};
//获取通知列表
const _getNoticeList = (data) => {
  return http.get(`/api/waiter/notices`, data).then(res => res.data)
};
//获取通知详情
const _getNoticeDetail = (id) => {
  return http.get(`/api/notices/${id}`).then(res => res.data)
};
//查询作业列表
const _getTaskList = (data, params) => {
  return http.post(`/api/tasks/manage`, data, params).then(res => res.data)
};
//查询老师作业详情
const _getTaskDetail = (id) => {
  return http.get(`/api/tasks/${id}`).then(res => res.data)
};
//查询学生作业详情
const _getStudentTaskDetail = (taskId, receiptId) => {
  return http.get(`/api/tasks/${taskId}/receipts/${receiptId}`).then(res => res.data)
};
//查询客服 列表
const _getCustomerList = (data) => {
  return http.get(`/api/waiter/customers`, data).then(res => res.data)
};
//查询客服详情
const _getCustomerDetail = (id, params) => {
  return http.get(`/api/waiter/customers/${id}/questions`, params).then(res => res.data)
};
//新增客服用户
const _addCustomer = (data) => {
  return http.post(`/api/waiter/customers`, data).then(res => res.data)
};
//添加客户问题记录
const _addCustomerRecord = (data) => {
  return http.post(`/api/waiter/customers/questions`, data).then(res => res.data)
};
//修改密码
const _changePassword = (data) => {
  return http.patch(`/api/user/password`, data).then(res => res.data)
};
//获取客服列表
const _getCustomerRoleList = () => {
  return http.get(`/api/waiters`).then(res => res.data)
};
//建立分块上传文件任务
const _filesTasks = (data) => {
  return http.post(`/api/files/tasks`, data).then(res => res.data)
};
//上传文件
const _filesTask = (data) => {
  return http.post(`/api/files`, data).then(res => res.data)
};
//建立分块上传文件任务
const _filesTasksEnd = (key) => {
  return http.post(`/api/files/tasks/${key}/end`).then(res => res.data)
};
//添加教辅
const _papersBooks = (data) => {
  return http.post(`/api/papers/books`, data).then(res => res.data)
};
//教辅申请铺码
const _papersBooksDotted = (id) => {
  return http.post(`/api/papers/books/${id}/dotted`).then(res => res.data)
};
//导入教辅切题框excel文件
const _papersBooksBoxes = (param) => {
  return http.post(`/api/papers/books/${param.id}/boxes`, param).then(res => res.data)
};
//生成教辅的切题框列表文件(EXCEL)
const _papersBooksBoxesTemplates = (id) => {
  return http.post(`/api/papers/books/${id}/boxes/templates`).then(res => res.data)
};
//检查教辅切题框excel文件
const _papersBooksBoxesDuplicates = (param) => {
  return http.post(`/api/papers/books/${param.id}/boxes/duplicates`, param).then(res => res.data)
};
//生成教辅的切题框校对文件(小样)
const _papersBooksBoxesPdf = (id) => {
  return http.post(`/api/papers/books/${id}/boxes/pdf`).then(res => res.data)
};
//查询教辅(我发布的)  查询教辅列表(客服)
const _gitPapersBooks = (page = 0) => {
  return http.get(`/api/papers/books?page=${page}&size=10&sort=createTime,desc`).then(res => res.data)
};
//查询教辅章节列表(我发布的)   查询教辅章节列表(客服)
const _papersTeachersSheets = (param) => {
  return http.get(`/api/papers/books/${param.id}/sheets?page=${param.page}&sort=seqno&size=${param.size}`).then(res => res.data)
};
//添加教辅章节
const _paperBookssSheets = (param) => {
  return http.post(`/api/papers/books/sheets`, param).then(res => res.data)
};
//生成教辅章节的切题框校对文件(章节小样)
const _paperBookssSheetsBoxes = (id) => {
  return http.post(`/api/papers/books/sheets/${id}/boxes/pdf`).then(res => res.data)
};
//教辅完成(生成教辅的所有班级的答题卡)
const _paperBookssTeachersClasses = (id) => {
  return http.post(`/api/papers/books/${id}/teachers/classes/sheets`).then(res => res.data)
};
//删除教辅/答题本等
const _deletePapers = (id) => {
  return http.delete(`/api/papers/${id}`).then(res => res.data)
};
//删除班级答题卡
const _deletePapersTeachers = (id) => {
  return http.delete(`/api/papers/sheets/${id}`).then(res => res.data)
};

//添加大题
const _addBigSubject = (data) => {
  return http.post(`/api/papers/sheets/sections`, data).then(res => res.data)
};
//查看某个答题卡详情
const _getAnswerCardDetail = (id) => {
  return http.get(`/api/papers/sheets/${id}`).then(res => res.data)
};
//小题属性修改
const _changeSmallAttr = (data) => {
  return http.post(`/api/papers/sheets/details`, data).then(res => res.data)
};
//编辑小题答案
const _editorSmallAnswer = (data) => {
  return http.patch(`/api/papers/sheets/details/answers`, data).then(res => res.data)
};
//发布答题卡
const _publishAnswerCard = (data) => {
  return http.post(`/api/papers/sheets/releases`, data).then(res => res.data)
};
//获取问题类型列表
const _getQuestionTypeList = () => {
  return http.get(`/api/papers/questions/types`).then(res => res.data)
};
//添加/修改答题本
const _editorAnswerCard = (data) => {
  return http.post(`/api/papers/cards`, data).then(res => res.data)
};
//查询答题本列表(我发布的)
const _getAnswerCardList = (data) => {
  return http.get(`/api/papers/cards`, data).then(res => res.data)
};
//查询答题本章节列表(我发布的)
const _getAnswerChapterList = (data) => {
  return http.get(`/api/papers/cards/${data.id}/sheets`, data).then(res => res.data)
};
//添加/修改答题本的章节
const _getConfirmAddChapter = (data) => {
  return http.post(`/api/papers/cards/sheets`, data).then(res => res.data)
};
//删除答题卡,删除章节
const _deleteChapter = (id) => {
  return http.delete(`/api/papers/sheets/${id}`).then(res => res.data)
};
//删除教辅、答题本
const _deleteAnswerCard = (id) => {
  return http.delete(`/api/papers/${id}`).then(res => res.data)
};
//答题本申请铺码
const _startLayingCode = (id) => {
  return http.post(`/api/papers/cards/${id}/dotted`).then(res => res.data)
};
//教辅章节申请铺码
const _startChapterLayingCode = (id) => {
  return http.post(`/api/papers/cards/sheets/${id}/dotted`).then(res => res.data)
};
//答题本下载（该请求成功后才能下载）
const _startDownloadUrl = (id) => {
  return http.post(`/api/papers/cards/${id}/files`).then(res => res.data)
};
//   答题本完成， 此操作后老师就可以查询到。
const _answerCardEnd = (id) => {
  return http.put(`/api/papers/cards/${id}/release`).then(res => res.data)
};
//查询标签列表
const _getLabelList = (params) => {
  return http.get(`/api/papers/labels`, params).then(res => res.data)
};
//添加标签
const _addLabel = (data) => {
  return http.post(`/api/papers/labels`, data).then(res => res.data)
};
//智慧笔统计
const _paperStatistics = (data) => {
  return http.get(`/api/paperStatistics/beginDate/${data.beginDate}/endDate/${data.endDate}`).then(res => res.data)
};
//获取蓝牙数据提交情况列表(客服调试)
const _bluetoothData = (data) => {
  return http.get(`/api/waiter/papers/pens/data`, data).then(res => res.data)
};
//查询学生蓝牙提交页列表(客服调试)
const _studentBlueToothList = (id, params) => {
  return http.get(`/api/waiter/papers/students/bluetooth/${id}`, params).then(res => res.data)
};
//查询老师蓝牙批改页列表(客服调试)
const _teacherJudgeList = (id, params) => {
  return http.get(`/api/waiter/papers/teachers/bluetooth/${id}`, params).then(res => res.data)
};
//查询学生答题卡详情(客服调试)
const _studentBluetoothDetails = (id) => {
  return http.get(`/api/waiter/papers/students/answers/${id}`).then(res => res.data)
};
// 设置答题图片[错题本]
const _setpapersimages = (data) => {
  return http.post(`/api/papers/sheets/details/images`, data).then(res => res.data)
};
// 查询教辅/答题本章节或答题卡的答题明细列表
const _getSheetsDetails = (params) => {
  return http.get(`/api/papers/sheets/${params.id}/details?page=${params.page}&size=1000`).then(res => res.data)
};
// 设置答题图片[错题本]
const _patchSheetsImages = (params) => {
  return http.patch(`/api/papers/sheets/details/images`, params).then(res => res.data)
};
// 删除答题图片[错题本]
const _deleteSheetsImages = (questionId) => {
  return http.delete(`/api/papers/sheets/details/${questionId}/images`).then(res => res.data)
};
//答题卡/教辅章节/答题本章节/用户标签等申请印刷模式铺码
const _printBooksDotted = (id) => {
  return http.post(`/api/papers/sheets/${id}/print`).then(res => res.data)
};
//生成当日错题本(客服)
const _createWrongList = () => {
  return http.get(`/api/waiter/paper/WrongQuestions/generate`).then(res => res.data)
};
//获取教辅切图章节列表
const _queryBookChapter = (id, page, size) => {
  return http.get(`/api/papers/books/${id}/sheets?page=${page}&size=${size}&sort=seqno`)
}
//查询教辅指定页的切题框
const _queryBookData = (id, pageSerialNo) => {
  return http.get(`/api/papers/books/sheets/${id}/pages/${pageSerialNo}/boxes`)
}
//查询教辅列表
const _booksList = (token, page, pageSize) => {
  return http.get(`/api/papers/books?page=${page}&size=${pageSize}&sort=createTime,desc`)
}
//查询教辅章节页对应列表
const _chapterId = (id) => {
  return http.get(`/api/papers/books/sheets/${id}/pages`)
}
//提交教辅切题框
const _areaBookData = (data) => {
  return http.post('/api/papers/books/boxes/pens/data', data)
}
//删除教辅切题框
const _deleteBorder = (sheetId, detailId) => {
  return http.delete(`/api/papers/books/sheets/${sheetId}/boxes/${detailId}`)
}
//删除指定学生的所有家长
const _deleteAllParents = (studentId) => {
  return http.delete(`/api/waiter/students/${studentId}/parents`).then(res => res.data)
};
//查询测试方案列表
const _getPlanList = (paramsInfo) => {
  return http.get(`/api/recognitionTest/scheme/list`, paramsInfo).then(res => res.data)
};
// 获取测试配置基础参数
const _getBasicsConfigInfo = () => {
  return http.get(`/api/recognitionTest/test/types`).then(res => res.data)
};
// 保存参数配置
const _holdParamsConfig = (data) => {
  return http.post(`/api/recognitionTest/parameter/save`, data).then(res => res.data)
};
//获取科目列表
const _getSubjectList = () => {
  return http.get(`/api/teachers/subjects`).then(res => res.data)
};
//查询参数配置
const _getConfigList = (paramsInfo) => {
  return http.get(`/api/recognitionTest/parameter/list`, paramsInfo).then(res => res.data)
};
//删除测试参数
const _deleteConfigItem = (id) => {
  return http.delete(`/api/recognitionTest/parameter/delete/${id}`).then(res => res.data)
};
//保存测试方案
const _holdTestPlan = (data) => {
  return http.post(`/api/recognitionTest/scheme/save`, data).then(res => res.data)
};
//删除测试方案
const _deletePlanItem = (id) => {
  return http.delete(`/api/recognitionTest/scheme/delete/${id}`).then(res => res.data)
};
//查询测试班级答题卡列表
const _getClassCardList = (param) => {
  return http.get(`/api/recognitionTest/papers/classSheetPage?page=${param.page}&sort=${param.sort}&size=${param.size}`).then(res => res.data)
};
//根据ID查询测试方案
const _getTestConfigDetail = (id) => {
  return http.get(`/api/recognitionTest/scheme/${id}`).then(res => res.data)
};
//答题卡复测
const _againTestPlan = (data) => {
  return http.post(`/api/recognitionTest/classSheet/retest?id=${data.id}&schemeId=${data.schemeId}`).then(res => res.data)
};
//查询班级答题卡测试结果列表
const _getCardOCRDetail = (data) => {
  return http.post(`/api/recognitionTest/papers/studentAnswerDetailPage?id=${data.id}&pagerSheetId=${data.pagerSheetId}&studentId=${data.studentId}&testNum=${data.testNum}`).then(res => res.data)
};
//教辅生成切题页图片
const _borderImage = (id) => {
  return http.post(`/api/papers/books/${id}/images`).then(res => res.data)
}
//教辅章节取消铺码
const _cacelDotted = (id) => {
  return http.delete(`/api/papers/books/sheets/${id}/dotted`).then(res => res.data)
}
//教辅生成切题框页图片(客服)
const _againProduceImage = (id) => {
  return http.post(`/api/papers/books/${id}/answers/images`).then(res => res.data)
};
//蓝牙数据重新批改
const _againCorrectBluetooth = (id) => {
  return http.post(`/api/waiter/papers/students/bluetooth/${id}`).then(res => res.data)
};
//批量更新章节下的题干图片(打包当前仅支持zip)
const _paperSsheetsImages = (data) => {
  return http.patch(`/api/papers/sheets/details/images/batch`, data).then(res => res.data)
};
//更改教辅指定框的信息(题型，识别类型，答案)
const _modifyInformation = (data) => {
  return http.patch(`/api/papers/books/sheets/boxes`, data).then(res => res.data)
}
//查询OCR识别参数列表
const _getOcrParams = () => {
  return http.get(`/api/waiter/parameter/list?size=10000&sort=createTime,desc`).then(res => res.data)
}
//小题复测
const _recognitionTestRetest = (data) => {
  return http.post(`/api/recognitionTest/detail/retest`, data).then(res => res.data)
}
//小题复测列表
const _recognitionTestRetestList = (id) => {
  return http.get(`/api/recognitionTest/detail/${id}/retest/list`).then(res => res.data)
};
//复测重新打分
const _againScoring = (data) => {
  return http.post(`/api/recognitionTest/detail/rescore`, data).then(res => res.data)
};
//重新批改指定小题
const _againCorrect = (id) => {return http.patch(`/api/papers/books/sheets/details/${id}`).then(res => res.data)};
// OCR参数推荐
const _submitType = (data) => {return http.post(`/api/recognitionTest/detail/ocrParamsRecommend`,data).then(res => res.data)}
//获取OCR识别库
const _getOCRList = () => { return http.get(`/api/recognitionTest/resource/list`).then(res => res.data)}
//获取识别结果替换规则
const _getReplaceList = () => {return http.get(`/api/recognitionTest/replace/list`).then(res => res.data)}
//获取判断规则
const _getJudgeList = () =>{return http.get(`/api/recognitionTest/judge/list`).then(res => res.data)}
//获取错误类型
const _recognitionTestErrortype = () => {
  return http.get(`/api/recognitionTest/detail/errortype`).then(res => res.data)
};
//错误标注
const _recognitionTestErrorMark = (param) => {
  return http.post(`/api/recognitionTest/detail/errorMark`, param).then(res => res.data)
};
//取消标注
const _recognitionTestCancelErrorMark = (param) => {
  return http.post(`/api/recognitionTest/detail/cancelErrorMark`, param).then(res => res.data)
};
//查询班级答题卡下的学生列表
const _recognitionTestStudents = (param) => {
  return http.get(`/api/recognitionTest/detail/${param.classSheetId}/student`).then(res => res.data)
};
//导出错误统计
const _recognitionExportErrorStatistics = (param) => {
  return http.post(`/api/recognitionTest/detail/exportErrorStatistics`, param).then(res => res.data)
};
//拷贝原始数据
const _recognitionCopyOriginalData = (param) => {
  return http.post(`/api/recognitionTest/detail/copyOriginalData`, param).then(res => res.data)
};

//清除指定手机的绑定关系(微信，用户，老师，家长，学生)，注意慎重提醒操作员。
const _deleteWaiterUsers = (phone) => {
  return http.delete(`/api/waiter/users/${phone}`);
};
// // 查询当前待审核文件列表
const _getVideoList = (params) => {return http.get(`/api/classes/files/audit/list`,params).then(res => res.data)};
//审核班级文件
const _approvalVideo = (fileIds,flag) => {return http.put(`/api/classes/files/audit/${fileIds}/${flag}`).then(res => res.data)};


export {
  _approvalVideo,
  _getVideoList,
  _recognitionCopyOriginalData,
  _recognitionExportErrorStatistics,
  _recognitionTestStudents,
  _recognitionTestErrortype,
  _recognitionTestErrorMark,
  _recognitionTestCancelErrorMark,
  _recognitionTestRetestList,
  _recognitionTestRetest,
  _paperSsheetsImages,
  _deleteSheetsImages,
  _patchSheetsImages,
  _getSheetsDetails,
  _setpapersimages,
  _papersBooksBoxes,
  _paperStatistics,
  _deletePapers,
  _deletePapersTeachers,
  _paperBookssTeachersClasses,
  _paperBookssSheetsBoxes,
  _papersTeachersSheets,
  _paperBookssSheets,
  _papersBooksBoxesPdf,
  _papersBooksBoxesTemplates,
  _papersBooksBoxesDuplicates,
  _gitPapersBooks,
  _papersBooksDotted,
  _filesTasks,
  _papersBooks,
  _filesTasksEnd,
  _getLoginCode,
  _confirmLogin,
  _getCaptcha,
  _getSchoolsList,
  _getStudentList,
  _getStudentDetail,
  _getClassesList,
  _getClassDetail,
  _getUserList,
  _getUserDetail,
  _getWxCode,
  _getNoticeList,
  _getNoticeDetail,
  _getTaskList,
  _getTaskDetail,
  _getStudentTaskDetail,
  _getCustomerList,
  _getCustomerDetail,
  _addCustomer,
  _addCustomerRecord,
  _changePassword,
  _getCustomerRoleList,
  _addBigSubject,
  _filesTask,
  _getAnswerCardDetail,
  _changeSmallAttr,
  _editorSmallAnswer,
  _publishAnswerCard,
  _getQuestionTypeList,
  _editorAnswerCard,
  _getAnswerCardList,
  _getAnswerChapterList,
  _getConfirmAddChapter,
  _deleteChapter,
  _deleteAnswerCard,
  _startLayingCode,
  _startDownloadUrl,
  _answerCardEnd,
  _getLabelList,
  _addLabel,
  _bluetoothData,
  _studentBlueToothList,
  _teacherJudgeList,
  _studentBluetoothDetails,
  _startChapterLayingCode,
  _printBooksDotted,
  _createWrongList,
  _queryBookChapter,
  _queryBookData,
  _chapterId,
  _areaBookData,
  _deleteBorder,
  _booksList,
  _deleteAllParents,
  _getPlanList,
  _getBasicsConfigInfo,
  _holdParamsConfig,
  _getSubjectList,
  _getConfigList,
  _holdTestPlan,
  _getClassCardList,
  _getTestConfigDetail,
  _getCardOCRDetail,
  _deleteConfigItem,
  _deletePlanItem,
  _againTestPlan,
  _borderImage,
  _cacelDotted,
  _againProduceImage,
  _againCorrectBluetooth,
  _modifyInformation,
  _getOcrParams,
  _againScoring,
  _againCorrect,
  _submitType,
  _getOCRList,
  _getReplaceList,
  _getJudgeList,
  _deleteWaiterUsers
}



// WEBPACK FOOTER //
// ./src/api/api.js